module.exports = __webpack_public_path__ + "static/media/beach1.bcfd771b.mp3";